/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CirclePause = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 19 19">
      <g>
        <path d="M9.5,1 C4.813,1 1,4.813 1,9.5 C1,14.187 4.813,18 9.5,18 C14.187,18 18,14.187 18,9.5 C18,4.813 14.187,1 9.5,1 M9.5,19 C4.262,19 0,14.738 0,9.5 C0,4.262 4.262,0 9.5,0 C14.738,0 19,4.262 19,9.5 C19,14.738 14.738,19 9.5,19" />
        <path d="M7.5 13C7.224 13 7 12.776 7 12.5L7 6.5C7 6.224 7.224 6 7.5 6 7.776 6 8 6.224 8 6.5L8 12.5C8 12.776 7.776 13 7.5 13M11.5 13C11.224 13 11 12.776 11 12.5L11 6.5C11 6.224 11.224 6 11.5 6 11.776 6 12 6.224 12 6.5L12 12.5C12 12.776 11.776 13 11.5 13" />
      </g>
    </BaseSvgIcon>
  )
}

export default CirclePause
